<template>
  <span style="cursor:pointer;" @click="openImsModal">{{ ImsDetail.seqNo }}</span>

  <div class="modal fade" tabindex="-1" :id="'Modal' + TbtnId"  v-if="active">
          <div class="modal-dialog modal-lg" >
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="editModalLabel">메시지 상세</h5>
        </div>

        <div class="modal-body">
          <table class="table">
            <tbody>
              <tr>
                <th>이름</th>
                <td style="text-align:center;">{{ Tsub.name }}</td>
                <th>ID</th>
                <td style="text-align:center;">{{ Tsub.username }}</td>
              </tr>
              <tr>
                <th>학원</th>
                <td style="text-align:center;">{{ Tsub.bizName }}</td>
                <th>등록일시</th>
                <td style="text-align:center;">{{ Tsub.intime }}</td>
              </tr>
              <tr>
                <th>수신번호</th>
                <td style="text-align:center;">{{ Tsub.callphone }}</td>
                <th>예약일시</th>
                <td style="text-align:center;">{{ Tsub.reqtime }}</td>
              </tr>
              <tr>
                <th>발송일시</th>
                <td style="text-align:center;">{{ Tsub.senttime }}</td>
                <th>발송상태</th>
                <td style="text-align:center;">{{ resultText(Tsub.result) }}</td>
              </tr>
              <tr>
                <th>내용</th>
                <td colspan="3" style="word-wrap: break-word; white-space: break-spaces; max-width: 400px;">
                  {{ Tsub.msg }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="flex_center">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal"> Close</button>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import axios from 'axios'
export default {
    "name": "ImsDetail",
    components: {

    },
    methods: {
      nvl(str, altStr){
        if(typeof str == "undefined" || str == null) str = altStr ;
         return str ;

      },
      openImsModal() {
        this.active = true;
        this.modifyMode(this.ImsDetail)
        //console.log(this.Tsub.bookclubs);
        this.$nextTick(function(){
          var modalDom = document.getElementById("Modal" + this.TbtnId);
          var modal = (bootstrap.Modal.getOrCreateInstance(modalDom));
          modalDom.addEventListener('hidden.bs#Modal', function (event) {
            this.active = false;
          })
          //console.log(modalDom);
          modal.show();

        });
      },
      doChange(name, value) {
        if (this.Tsub[name] === value) {
          delete this.changedData[name];
        } else {
          this.changedData[name] = value;
        }
      },
      modifyMode(record){
        this.creating = false;
        this.changedData = {};
        this.Tsub =  {
          "seqNo": record.seqNo,
          "intime": record.intime,
          "username": record.username,
          "name": record.name,
          "kind": record.kind,
          "callphone": record.callphone,
          "reqtime": record.reqtime,
          "senttime": record.senttime,
          "result": record.result,
          "etc1": record.etc1,
          "etc2": record.etc2,
          "etc3": record.etc3,
          "etc4": record.etc4,
          "msg": record.msg,
          "biz": record.biz,
          "p_biz": record.p_biz,
          "bizName": record.bizName,
        }
      },
    },
        mounted() {
      this.Tsub = this.ImsDetail;
      //console.log(this.Tsub.bookclubs);
    },
    watch: {
      sub(){
        alert('tsub has been updated')
              this.Tsub = this.ImsDetail;
      }
    },
    props: {
      ImsDetail: {
        type: Object,
        default: {}
      },
      btnId: String
    },
    computed: {
      resultText() {
        return function(result) {
          switch (result) {
              case '0':
                  return '대기';
              case '1':
                  return '모듈에서 데이터를 읽은 상태';
              case 'Y':
                  return '발송 요청 성공 (발송 성공 x)';
              case 'N':
                  return '발송 요청 실패';
              case '2':
                  return '발송 최종 성공';
              case '4':
                  return '발송 최종 실패';
              default:
                  return result; // 알 수 없는 상태의 경우 기본 값 표시
          }
        }
      }
    },
    data(){
        return {
            TbtnId: this.btnId || Math.random().toString().substr(2, 5),
            creating: false,
            active: false,
            Tsub: {
              "seqNo": "",
              "intime": "",
              "username": "",
              "name": "",
              "kind": "",
              "callphone": "",
              "reqtime": "",
              "senttime": "",
              "result": "",
              "etc1": "",
              "etc2": "",
              "etc3": "",
              "etc4": "",
              "msg": "",
              "biz": "",
              "p_biz": "",
              "bizName": "",
            },
            changedData: {
              "seqNo": "",
              "intime": "",
              "username": "",
              "name": "",
              "kind": "",
              "callphone": "",
              "reqtime": "",
              "senttime": "",
              "result": "",
              "etc1": "",
              "etc2": "",
              "etc3": "",
              "etc4": "",
              "msg": "",
              "biz": "",
              "p_biz": "",
              "bizName": "",
            },
            product: null
        }
    }
}
</script>

<style>

</style>
